<template>
  <div class="site-basic-container">
    <div class="site-basic-form">
      <div class="site-basic-header">
        <h2>基本设置</h2>
        <p>网站基本信息配置</p>
      </div>

      <el-form :model="form" label-width="120px">
        <el-form-item label="网站标题">
          <el-input v-model="form.siteTitle" placeholder="请输入网站标题"></el-input>
        </el-form-item>
        <el-form-item label="网站域名">
          <el-input v-model="form.siteDomain" placeholder="请输入网站域名"></el-input>
        </el-form-item>
        <el-form-item label="网站描述">
          <el-input
            v-model="form.siteDescription"
            type="textarea"
            :rows="3"
            placeholder="请输入网站描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="网站关键词">
          <el-input
            v-model="form.siteKeywords"
            placeholder="请输入网站关键词，多个关键词用逗号分隔"
          ></el-input>
        </el-form-item>
        <el-form-item label="版权信息">
          <el-input
            v-model="form.copyright"
            placeholder="请输入版权信息"
          ></el-input>
        </el-form-item>
        <el-form-item label="备案号">
          <el-input v-model="form.ICP" placeholder="请输入ICP备案号"></el-input>
        </el-form-item>
        <el-form-item label="联系邮箱">
          <el-input v-model="form.contactEmail" placeholder="请输入联系邮箱"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.contactPhone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="水印内容">
          <el-input v-model="form.watermarkText" placeholder="请输入水印文字内容"></el-input>
          <div class="form-tip">开启水印的订阅方案将使用此水印内容</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveSettings">保存设置</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SiteBasic',
  data() {
    return {
      loading: false,
      form: {
        siteTitle: '韦小布AI',
        siteDomain: 'https://wxb.5917tcpk.cn',
        siteDescription: 'AI 赋能超级个体，一人成就一家公司',
        siteKeywords: 'AI, 图片生成, 视频生成, 短剧生成, 智能助手',
        copyright: '© 2025 韦小布AI 版权所有',
        ICP: '京ICP备12345678号',
        contactEmail: 'lirui9894@qq.com',
        contactPhone: '13800138000',
        watermarkText: '韦小布AI'
      }
    }
  },
  mounted() {
    this.initSettings()
  },
  methods: {
    initSettings() {
      this.loading = true
      axios.get('/admin/site-basic')
        .then(response => {
          if (response.data.code === 200) {
            this.form = response.data.data
          }
        })
        .catch(() => {
          this.$message.error('获取设置失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveSettings() {
      this.loading = true
      axios.put('/admin/site-basic', this.form)
        .then(() => {
          this.$message.success('设置保存成功')
        })
        .catch(() => {
          this.$message.error('保存设置失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetForm() {
      this.initSettings()
      this.$message.info('表单已重置')
    }
  }
}
</script>

<style scoped>
.site-basic-container {
  padding: 20px 0;
}

.site-basic-form {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.site-basic-header {
  margin-bottom: 30px;
}

.site-basic-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.site-basic-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.config-tip {
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 15px;
  font-size: 14px;
  line-height: 1.8;
  color: #666;
}

.config-tip p {
  margin: 0 0 8px 0;
}

.config-tip p:last-child {
  margin-bottom: 0;
}

.config-tip code {
  background: #e8e8e8;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: Consolas, Monaco, monospace;
  color: #c7254e;
}

.form-tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
  line-height: 1.6;
}
</style>